import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Experience } from './Experience';
import { ReadTheTour } from './ReadTheTour';
import { About } from './About';
import { Credits } from './Credits';
import { Sources } from './Sources';

/**
 * Router — Phase 7 Wave 0 foundation. BrowserRouter (NOT HashRouter —
 * HashRouter is explicitly ruled out because HOST-04's vista permalinks
 * reserve the URL hash for camera/era state; see 07-RESEARCH.md
 * Anti-Patterns).
 *
 * Five sibling routes + one catch-all. Cloudflare Pages SPA fallback is
 * provided via `public/_redirects` (rewrites unknown paths to /index.html
 * with 200) so hard-refresh on /read, /about, /credits, or /sources
 * resolves to this Router instead of a 404.
 *
 * The 404 catch-all routes to <About /> per plan spec — About is the
 * project's canonical landing-without-3D surface.
 */
export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Experience />} />
        <Route path="/read" element={<ReadTheTour />} />
        <Route path="/about" element={<About />} />
        <Route path="/credits" element={<Credits />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="*" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}
